import React, { memo, useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import { IOption } from 'components/Select/interface';
import { Column, Row } from 'components/Layout/Grid';
import Select from 'components/Select';
import Text from 'components/Text';

import BusServices from 'services/bus.service';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';
import { EnumUserType } from 'models/User';

import { BUComponentProps } from './interface';

const BU: React.FC<BUComponentProps> = (props) => {

  const { setBuSelected, buSelected } = props;

  const user = useSelector((state: RootState) => state.user);

  const [bus, setBus] = useState<IOption[]>();

  const _busServices = new BusServices();

  const getBus = useCallback(async () => {

    const response = await _busServices.get(undefined, undefined, 'identifier asc');
    const { data } = response;
    const _busOption: Array<IOption> = new Array<IOption>();

    Object.keys(data).forEach((key) => {
      _busOption.push({
        value: data[key].id,
        label: `${data[key].identifier} - ${data[key].name}`
      });
    });

    setBus(_busOption);
  }, []);

  useEffect(() => {
    KeycloakPubServiceInstance.subscribe(() => {
      getBus();
    });
  }, [getBus]);

  // useEffect(() => {
  //   if (conditionIfBuSelected())
  //     return;

  //   setBuSelected(order ? order?.businessUnits : "");
  // }, [order]);

  // const conditionIfBuSelected = () => {
  //   if (buSelected && !order) {
  //     setBuSelected("");
  //     return true;
  //   }
  //   if (buSelected && !order?.businessUnits)
  //     return true;

  //   if ((buSelected && order) && (buSelected !== order?.businessUnits)) {
  //     setBuSelected(order?.businessUnits);
  //     return true;
  //   }

  //   return false;
  // };

  const validateRequired = () => {
    if (user?.userType === EnumUserType.EMPLOYEE)
      return true;

    return false;
  };

  return (
    <Row className="flex-md-column">
      <Column className="flex-1 mt-5 ml-4 ml-sm-0">
        <Text className="mb-2 color-blue-gray" size={12}>
          BU
        </Text>
        <Select
          required={validateRequired()}
          name="BU"
          data-testid="bu"
          data-statename="bus"
          value={buSelected}
          onChange={(e) => setBuSelected(e.target.value)}
          className="w-lg-100"
          width="280px"
          options={bus}
          id="bu-select"
        />
      </Column>
    </Row>
  );
};

export default memo(BU);
